import { Paragraph } from 'ui-components';
import { humanizeDate } from '~/utils';

export function PlatformChartsCaptionLastUpdatedText({
  demographicsLastUpdatedAt,
}: {
  demographicsLastUpdatedAt?: string;
}) {
  return (
    <Paragraph sx={{ marginTop: 'spacing-200' }} size="sm" color="primary.300">
      Last updated {humanizeDate(demographicsLastUpdatedAt)}.
    </Paragraph>
  );
}
